// extracted by mini-css-extract-plugin
module.exports = {"selectTag":"antd-pro-pages-home-microsite-article-submissions-create-video-select-tag-index-selectTag"};